module.exports = __webpack_public_path__ + "img/product-preview-28.6297356.png";